module.exports = __webpack_public_path__ + "static/media/student-score-end.e7bc20fd.png";